export const LoginHero = 'https://ik.imagekit.io/duckbill/prod/login-hero.jpeg?updatedAt=1717795860190';
